export {default} from './PrivacyPolicy'
